module.exports = __webpack_public_path__ + "static/media/rogue_bg.69d1a070.jpeg";